import { ExternalLink, Headset, ShieldCheck, Sparkles } from 'lucide-react';
import Badge from '../components/ui/Badge';
import Button from '../components/ui/Button';
import Card from '../components/ui/Card';
import PageHeader from '../components/shared/PageHeader';
import BrandLogo from '../components/shared/BrandLogo';
import PlanBrand from '../components/shared/PlanBrand';
import gdnLogo from '../assets/gdn-logo.jpeg';

const siteUrl = 'https://gdncorp.com.br';

export default function Sobre() {
  return (
    <div className="space-y-4">
      <PageHeader title="Sobre o MecSync" subtitle="Informações do sistema e suporte GDN Corp" />

      <Card className="overflow-hidden">
        <div className="grid gap-6 lg:grid-cols-[1.1fr_0.9fr]">
          <div>
            <BrandLogo size="md" />
            <div className="mt-2 flex items-center gap-2">
              <Badge tone="aberta">Versão 1.0.0</Badge>
              <span className="text-xs font-semibold uppercase tracking-widest text-zinc-500">Gestão inteligente</span>
            </div>
            <p className="mt-4 max-w-3xl text-sm leading-6 text-zinc-300">
              O MecSync é um sistema de gestão para oficinas mecânicas desenvolvido para centralizar clientes,
              veículos, ordens de serviço, estoque, agenda, financeiro e comunicação em uma operação simples,
              organizada e conectada aos dados reais da oficina.
            </p>
            <div className="mt-5 grid gap-3 md:grid-cols-3">
              <div className="rounded-lg bg-surface2 p-3">
                <ShieldCheck size={18} className="mb-2 text-orange-400" />
                <p className="text-sm font-semibold">Controle operacional</p>
              </div>
              <div className="rounded-lg bg-surface2 p-3">
                <Headset size={18} className="mb-2 text-orange-400" />
                <p className="text-sm font-semibold">Atendimento integrado</p>
              </div>
              <div className="rounded-lg bg-surface2 p-3">
                <Sparkles size={18} className="mb-2 text-orange-400" />
                <p className="text-sm font-semibold">Premium IA</p>
              </div>
            </div>
            <div className="mt-5 rounded-lg border border-yellow-400/20 bg-yellow-400/5 p-4">
              <PlanBrand plan="Premium" compact />
              <p className="mt-3 text-sm leading-6 text-zinc-300">
                No MecSync Premium, a Synes.ia entrega a camada de WhatsApp automatizado, CRM completo e orquestracao comercial com IA dentro da experiencia do sistema.
              </p>
            </div>
          </div>

          <div className="rounded-lg border border-white/[0.06] bg-[#0f172a] p-5">
            <img src={gdnLogo} alt="GDN Corp" className="h-auto w-44 rounded-lg bg-[#111113] p-2 object-contain" />
            <h3 className="mt-4 font-display text-2xl">GDN Corp</h3>
            <p className="mt-2 text-sm leading-6 text-zinc-300">
              Empresa responsável pelo desenvolvimento, implantação e suporte do MecSync, com atuação em
              automação, sistemas, integrações e soluções digitais para empresas brasileiras.
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              <Button onClick={() => window.open('mailto:contato@gdncorp.com.br?subject=Suporte%20MecSync', '_blank', 'noopener,noreferrer')}>
                <Headset size={16} />
                Suporte GDN Corp
              </Button>
              <Button variant="ghost" onClick={() => window.open(siteUrl, '_blank', 'noopener,noreferrer')}>
                <ExternalLink size={16} />
                Site GDN Corp
              </Button>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
}
